import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export const CompassControl = () => {
  const map = useMap();

  useEffect(() => {
    if (map.compassControl) return;
    const compass = L.control({ position: 'topleft' });

    compass.onAdd = () => {
        const div = L.DomUtil.create('div', 'custom-compass');
        div.style.width = '40px';
        div.style.height = '40px';
        div.style.background = 'rgba(255, 255, 255, 0.8)';
        div.style.borderRadius = '50%';
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.justifyContent = 'center';
        div.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
        div.style.cursor = 'default'; // Pas cliquable
        div.innerHTML = `
          <div
            style="
              width: 0; 
              height: 0; 
              border-left: 6px solid transparent; 
              border-right: 6px solid transparent; 
              border-bottom: 12px solid #007bff; 
              transform: translateY(-2px);
            "
          ></div>
        `;
        return div;
      };

    compass.addTo(map);

    map.compassControl = compass;
    
  }, []);

  return null;
};